<template>
    <div class="screen-preview" :class="{ simple, editable }">
        <Screen
            :screen="_screen"
            :course="course"
            :simple="simple"
            :editable="editable"
            :style="{ transform: `scale(${scale})` }"
            thumbnail
            @image:loaded="$emit('image:loaded')"
        />
    </div>
</template>

<script>
import { useResponsive, getElement } from '@/store/responsive';

import Screen from '@/components/author/screen';
import { finishScreen } from '@/helpers/course';

export default {
    name: 'ScreenPreview',
    components: { Screen },
    props: {
        screen: { type: Object, default: null },
        course: { type: Object, default: null },

        simple: { type: Boolean, default: false },
        editable: { type: Boolean, default: false },
        finish: { type: Boolean, default: false },
        headless: { type: Boolean, default: false }
    },
    emits: ['update:screen', 'image:loaded'],
    computed: {
        component() {
            return getElement(this);
        },
        scale() {
            return this.component.width / 1170;
        },
        _screen() {
            if (this.finish) return finishScreen(this.course, false, this.headless);
            return this.screen;
        }
    },
    mounted() {
        useResponsive(this, this.$el);
    },
    beforeUnmount() {
        useResponsive.removeElement(this);
    },
};
</script>

<style lang="less" scoped>
.screen-preview {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    user-select: none;
    pointer-events: none;
    overflow: hidden;
    > * {
        width: 1170px;
        height: 835px;
        transform-origin: top left;
        --screen-padding: 96px;
        --bleed: 0px;
    }
    &.simple {
        > * {
            height: 720px;
        }
    }
    &.editable { pointer-events: auto; }
}
</style>

<style lang="less">
.screen-preview {
    .float-nav { display: none; }
    &.editable {
        .float-nav { display: none; }
    }
    .draglist .droppable.clickable > * { pointer-events: none; }
}
</style>
